module.exports = __webpack_public_path__ + "img/bg-header2.10e3c074.jpg";